import * as COLORS from './colors';

export const getAlertColor = (alertType: number) => {
  switch (alertType) {
    case 3: // Unit entered Geofence
    case 4: // Unit leaves Geofence
    case 8: // Unit not sent data for a period of time
      return '#fd7e14'; // orange-600
    case 26: // Unit out of Route
      return '#c92a2a'; // red-900
    default:
      return COLORS.COLOR_7P_TEAL;
  }
};
